{
  "version": "1.2.6",
  "objects": {
    "7452844833728799258": {
      "type": "frame",
      "id": "7452844833728799258",
      "z": 9211,
      "textContent": "",
      "left": 512.8134660123736,
      "top": 71.45961745598686,
      "width": 400,
      "height": 500,
      "scaleX": 1.1088629399607317,
      "scaleY": 0.8182379788611093,
      "fill": "#FFFFFF",
      "opacity": 1,
      "notInNavigation": false,
      "componentName": "",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "user",
      "layoutSizeVertical": "user",
      "layoutGap": 10,
      "layoutPadding": 30,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "top"
    },
    "7452844833721789633": {
      "type": "frame",
      "id": "7452844833721789633",
      "z": 34,
      "textContent": "Frame 57",
      "left": 542.8134660123736,
      "top": 425.5786068865415,
      "width": 400,
      "height": 500,
      "scaleX": 0.9588629399607317,
      "scaleY": 0.05,
      "fill": "transparent",
      "opacity": 1,
      "container": "7452844833728799258",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a1",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "children",
      "layoutGap": 10,
      "layoutPadding": 0,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "left",
      "layoutAlignVertical": "center"
    },
    "7452844833733291772": {
      "type": "shape",
      "id": "7452844833733291772",
      "z": 85,
      "shapeName": "text",
      "textContent": "<p>Description</p>",
      "left": 542.8134660123736,
      "top": 425.5786068865415,
      "width": 442.93069086483524,
      "height": 29.015542656896027,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 0.8616071839710477,
      "scaleY": 0.8616071839710477,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textOpacity": 0.4,
      "textAlign": "left",
      "fontSize": 12.062500575594669,
      "angle": 0,
      "container": "7452844833721789633",
      "authorId": "7514551366124436458",
      "showAuthor": true,
      "layoutPosition": "a0",
      "wrapText": true,
      "maskType": "none",
      "locked": false,
      "reactions": {}
    },
    "7452844833724492878": {
      "type": "frame",
      "id": "7452844833724492878",
      "z": 51,
      "textContent": "Frame 56",
      "left": 542.8134660123736,
      "top": 132.4624990788285,
      "width": 400,
      "height": 500,
      "scaleX": 0.9588629399607317,
      "scaleY": 0.5662322156154259,
      "fill": "#16A468",
      "opacity": 0.05,
      "container": "7452844833728799258",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a0",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "parent",
      "layoutGap": 10,
      "layoutPadding": 10,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7452844833735442968": {
      "type": "wireframe",
      "id": "7452844833735442968",
      "z": 8946,
      "top": 179.770552982685,
      "left": 640.83605400452,
      "width": 150,
      "height": 150,
      "scaleX": 1.25,
      "scaleY": 1.25,
      "container": "7452844833724492878",
      "wireframeName": "video",
      "fill": "#16A468",
      "textColor": "#333333",
      "style": "video",
      "fontSize": 14,
      "label": {},
      "placeholder": {}
    },
    "7452844833731142148": {
      "type": "frame",
      "id": "7452844833731142148",
      "z": 102,
      "textContent": "Frame 98",
      "left": 542.8134660123736,
      "top": 101.45961745598686,
      "width": 400,
      "height": 500,
      "scaleX": 0.9588629399607317,
      "scaleY": 0.042005763245683246,
      "fill": "#FFFFFF",
      "opacity": 1,
      "container": "7452844833728799258",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": null,
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "children",
      "layoutGap": 10,
      "layoutPadding": 0,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "right",
      "layoutAlignVertical": "center"
    },
    "7452844833720275429": {
      "type": "shape",
      "id": "7452844833720275429",
      "z": 119,
      "shapeName": "icon",
      "textContent": "",
      "left": 911.2318409823903,
      "top": 102.45961745598686,
      "width": 100,
      "height": 160,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 0.13126801014276016,
      "scaleY": 0.13126801014276016,
      "stroke": null,
      "strokeWidth": 2,
      "opacity": 0.3,
      "borderOpacity": 1,
      "fill": "#333333",
      "angle": 0,
      "container": "7452844833731142148",
      "authorId": "7514551366124436458",
      "showAuthor": true,
      "layoutPosition": "a0",
      "maskType": "none",
      "iconName": "fas/xmark",
      "locked": false
    }
  }
}
